module.exports = __webpack_public_path__ + "static/media/prize-8.90e0f3b2.png";